import * as React from "react";
import styled from "styled-components";
import { KEY_ESC, KEY_TAB } from "./dropdown.consts";

export class HoverDropdown extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  handleOpenEvent = () => {
    this.setState(this.openDropdown);
  };

  handleCloseEvent = () => {
    this.setState(this.closeDropdown);
  };

  openDropdown = () => ({ open: true });

  closeDropdown = () => ({ open: false });

  // TODO: Add functionality to focus menu item children
  handleKeyDown = (e: { keyCode: any; shiftKey: any }) => {
    switch (e.keyCode) {
      case KEY_TAB:
        if (!this.state.open) {
          if (!e.shiftKey) {
            this.handleOpenEvent();
          }
        } else if (e.shiftKey) {
          this.handleCloseEvent();
        }

        break;
      case KEY_ESC:
        this.handleCloseEvent();
        break;
      default:
    }
  };

  handleToggleFocus = () => {
    this.handleOpenEvent();
  };

  addTogglePropsToChild = (ChildComponent) =>
    React.cloneElement(ChildComponent, {
      open: this.state.open,
      onFocus: this.handleToggleFocus,
    });

  addMenuPropsToMenu = (MenuComponent) =>
    React.cloneElement(MenuComponent, {
      open: this.state.open,
      onCloseButtonClick: this.handleCloseEvent,
    });

  render() {
    const { className, ...otherProps } = this.props;
    let { children, menu } = this.props;

    menu = this.addMenuPropsToMenu(menu);

    children = React.Children.map(children, this.addTogglePropsToChild);

    return (
      <div
        className={className}
        onKeyDown={this.handleKeyDown}
        onMouseEnter={this.handleOpenEvent}
        onMouseLeave={this.handleCloseEvent}
        {...otherProps}
      >
        {children}
        {menu}
      </div>
    );
  }
}

export default styled(HoverDropdown)`
  position: relative;

  > div {
    > .md-icon {
      color: ${(p) => p.theme.colors.secondary};
      &.symbol {
        margin-bottom: 5px;
        margin-right: 10px;
      }

      &.chevron {
        margin-bottom: 2px;
        color: ${(p) => p.theme.colors.grey300};
      }
    }
  }

  &:hover {
    > div {
      > i,
      > span {
        color: ${(p) => p.theme.colors.primary};
      }

      > .md-icon {
        &.chevron {
          color: ${(p) => p.theme.colors.primary};
        }
      }
    }
  }
`;
